export default __webpack_public_path__ + "static/media/cv151.6875f4d6.png";